import React, { Component } from 'react';
import AOS from 'aos';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faMagic, faTheaterMasks, faDove } from '@fortawesome/free-solid-svg-icons'
import { faReact, faJs, faAdobe, faSketch, faCodepen, faFacebook, faBloggerB, faInstagram, faGithub } from '@fortawesome/free-brands-svg-icons'
import { Link } from 'react-router-dom';

 
class Contact extends Component {

  componentDidMount(){
    window.scrollTo({'top':0});

    AOS.init({
      duration : 1000
    });
  }

  render() {
    return (
      <React.Fragment>

          <div className="section_copy">
              <p className="cate">Contact</p>
              <p className="desc">
                  전화 및 메일문의
              </p>
              <p className="desc2">
                chinamagic8@naver.com
              </p>
          </div>

          <div className="btn_wrap">
            <a className="btn action" href="tel:010-8888-8084" target="_blank">
              010 - 8888 - 8084
            </a>
          </div>
             
          <section data-aos="fade-up" className="link">

            <div className="icowrap">
              <a href="https://www.instagram.com/chinamagic8" target="_blank">
                <div className="ico" data-aos="fade-up" data-aos-delay="0">
                    <FontAwesomeIcon icon={faInstagram} />
                </div>
              </a>

              <a href="https://www.facebook.com/chinamagic8" target="_blank">
                <div className="ico" data-aos="fade-up" data-aos-delay="0">
                    <FontAwesomeIcon icon={faFacebook} />
                </div>
              </a>

              <a href="https://blog.naver.com/chinamagic8" target="_blank">
                <div className="ico" data-aos="fade-up" data-aos-delay="0">
                    <FontAwesomeIcon icon={faBloggerB} />
                </div>
              </a>

              <a href="mailto:chinamagic8@naver.com" target="_blank">
                <div className="ico" data-aos="fade-up" data-aos-delay="600">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
              </a>
             
            </div>


          </section>


      </React.Fragment>
    );
  }
}

export default Contact;
